import { createSelector } from 'reselect'
import { months } from 'constants/arrays'

const getState = state => state.date
const dateSelector = state => getState(state).date
const dateRangeSelector = state => getState(state).dateRange

const monthSelector = createSelector(
  dateSelector,
  date => date.getMonth()
)

const monthLabelSelector = createSelector(
  monthSelector,
  month => months[month]
)

const yearSelector = createSelector(
  dateSelector,
  date => date.getFullYear()
)

export {
  monthSelector,
  dateSelector,
  monthLabelSelector,
  yearSelector,
  dateRangeSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/DateSelectors.js